export default __webpack_public_path__ + "static/media/user_nft_06.dc889d28.svg";